import { Component, Prop, Vue } from 'vue-property-decorator';

import { WaitingQueueEvent } from '@/views/checkout/interfaces';

@Component({
    data() {
        return {
            title: '',
            timeoutIds: []
        };
    }
})
export default class WaitingQueue extends Vue {
    @Prop(Array)
    queue: Array<WaitingQueueEvent>;

    title: string;
    timeoutIds: Array<number>;

    mounted() {
        this.title = '';
        this.queue.forEach((queueItem) => {
            this.timeoutIds.push(setTimeout(() => {
                this.title = queueItem.message || '';
                this.$emit('change', queueItem.id);
            }, queueItem.interval));
        });
    }

    destroyed() {
        this.title = '';
        this.timeoutIds.forEach((timeoutId) => {
            clearTimeout(timeoutId);
        });
    }
}
